<template>
  <div class="sample-detail-billing-info">
    <h3>Billing Information</h3>
    <section>
      <div class="form-group flex-group multiple-texts">
        <div class="form-field form-checkbox">
          <input
            id="isBillable"
            class="k-checkbox"
            type="checkbox"
            v-model="sampleData.isBillable"
            tabindex="400"
          />
          <label class="k-checkbox-label" for="isBillable">Billable</label>
        </div>
        <AutoComplete
          :formData="sampleData"
          :mapping="mappings.ThirdParty"
          store="ThirdParty"
          :tabindex="405"
          :allowAdditions="true"
          placeholder="Third Party" />
        <div class="form-field form-checkbox">
          <input
            id="isBasicSample"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingBasicSample"
            tabindex="410"
          />
          <label class="k-checkbox-label" for="isBasicSample">Basic Sample</label>
        </div>
      </div>
    </section>
    <div class="form-group billing-checks" v-if="sampleData.isBillable">
      <div class="checkbox-row">
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="tbn"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingTbn"
            tabindex="420"
          />
          <label class="k-checkbox-label" for="tbn">BN (D4739)</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="bn"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingBn"
            tabindex="420"
          />
          <label class="k-checkbox-label" for="bn">BN (D2896)</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="tan"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingTan"
            tabindex="415"
          />
          <label class="k-checkbox-label" for="tan">AN (D664)</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="kf"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingKf"
            tabindex="425"
          />
          <label class="k-checkbox-label" for="kf">KF</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="pc"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingPc"
            tabindex="430"
          />
          <label class="k-checkbox-label" for="pc">PC</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="gly"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingGly"
            tabindex="435"
          />
          <label class="k-checkbox-label" for="gly">GLY</label>
        </div>
      </div>
      <div class="checkbox-row">
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="sul"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingSul"
            tabindex="440"
          />
          <label class="k-checkbox-label" for="sul">SUL</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="nc"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingNc"
            tabindex="445"
          />
          <label class="k-checkbox-label" for="nc">NC</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="nob"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingNob"
            tabindex="450"
          />
          <label class="k-checkbox-label" for="nob">NOB</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="cl"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingCl"
            tabindex="455"
          />
          <label class="k-checkbox-label" for="cl">CL</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input
            id="rush"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingRush"
            tabindex="460"
          />
          <label class="k-checkbox-label" for="rush">RUSH</label>
        </div>
      </div>
    </div>
    <br />
    <div v-if="sampleData.isBillable" class="form-field flex-group form-group top-align">
      <label class="k-textbox-label" for="billingDesc">Billing Description</label>
      <textarea
        v-model="sampleData.billingDescription"
        id="billingDesc"
        class="k-textarea"
        tabindex="465"
      >
      </textarea>
    </div>
  </div>
</template>

<script>
import AutoComplete from '../../shared/AutoComplete.vue';

export default {
  name: 'SampleDetailBillingInfo',
  props: {
    sampleData: {
      type: Object,
      required: true
    },
    mappings: {
      type: Object,
      required: true
    }
  },
  components: {
    AutoComplete
  }
};
</script>
<style lang="scss" scoped>
section {
  border-color: $black;
  border-style: dotted;
  border-width: 0 0 1px;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.billing-checks,
section {
  padding-left: 131px;
}

.checkbox-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.checkbox-col {
  display: flex;
  flex: 1;
  flex-direction: column;
}
</style>
